import { memo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";
import { PERMISSIONS } from "shared/Actions/constants";

import { RenderGroupRowCellProps } from "../../Group/Content";
import PersonalSettingsSpacesItemCell from "../Cell";
import { isActionItem } from "../../../helpers";

const PersonalSettingsSpacesTableGroupRowCellPermissions = memo(
  (props: RenderGroupRowCellProps) => {
    const { row } = props;
    const permission = isActionItem(row) && PERMISSIONS[row.actionID];

    return (
      <PersonalSettingsSpacesItemCell {...props} role="rowheader">
        <TableCellText>
          {permission ? `${permission.subject} ${permission.name}` : ""}
        </TableCellText>
      </PersonalSettingsSpacesItemCell>
    );
  }
);

PersonalSettingsSpacesTableGroupRowCellPermissions.displayName =
  "PersonalSettingsSpacesTableGroupRowCellPermissions";

export default PersonalSettingsSpacesTableGroupRowCellPermissions;
